var map = {
	"./Grok Илона.mp3": 1671,
	"./StormBlack.mp3": 2394,
	"./Stormик Stormик Blackчик.m4a": 5046,
	"./Всевозможный.mp3": 3624,
	"./Всеспособный.mp3": 8111,
	"./Всё сейчас.mp3": 3465,
	"./Зайду в AiMethod.mp3": 7165,
	"./Закон хака.m4a": 3855,
	"./Индустрия хакания.mp3": 2141,
	"./Как сервер нужно хакнуть.mp3": 2159,
	"./Летай со StormBlack.mp3": 9478,
	"./Ломай.m4a": 6152,
	"./Наш сосед - StormBlack.mp3": 9801,
	"./Новенький сервер.mp3": 8633,
	"./Новый сайт StormBlack.mp3": 7193,
	"./Ркон пароль.mp3": 9491,
	"./Сервак.mp3": 3096,
	"./Сервера.mp3": 1823,
	"./Я же StormBlack прогою.mp3": 9508,
	"./Я зашёл на StormBlack.mp3": 8783,
	"./Я не Kabluk со StormBlack.mp3": 6418,
	"./Я тариф всё равно продлю.mp3": 9272
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2069;